// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.list__awcDnpxG8n{width:272px}.item__S6LPVIk22m{display:flex;align-items:center;justify-content:space-between}`, "",{"version":3,"sources":["webpack://./src/app/views/layout/views/dashboard/views/favorite/components/controls/components/preferences/favoriteDashboardPreferencesControl.module.scss"],"names":[],"mappings":"AAAA,kBACE,WAAA,CAGF,kBACE,YAAA,CACA,kBAAA,CACA,6BAAA","sourcesContent":[".list {\n  width: 272px;\n}\n\n.item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": `list__awcDnpxG8n`,
	"item": `item__S6LPVIk22m`
};
export default ___CSS_LOADER_EXPORT___;
